/*
 * @Description:
 * @Author: liangziyao
 * @Date: 2021-08-23 19:56:24
 */
import { deviceType } from "./utils";

const translatePosiPC = [
  { x: 180, y: 170 },
  { x: 240, y: 110 },
  { x: 300, y: 76 },
  { x: 90, y: 110 },
  { x: 10, y: 170 },
  { x: 10, y: 90 },
  { x: 100, y: 180 },
  { x: 160, y: 110 },
  { x: 310, y: 170 },
  { x: 250, y: 210 }
]

const translatePosiMobile = [
  { x: 200, y: 210 },
  { x: 280, y: 146 },
  { x: 370, y: 120 },
  { x: 100, y: 140 },
  { x: 10, y: 220 },
  { x: 15, y: 120 },
  { x: 100, y: 240 },
  { x: 180, y: 130 },
  { x: 364, y: 230 },
  { x: 280, y: 260 }
]

class Animation {
  $ = null;
  isPlaying = false;
  frame = 0;
  randomIndex = 0;
  stopMark = [];
  stopFrame = 0;
  isInit = false;
  container = null;
  containerWidth = 0;
  containerHeight = 0;
  eggsArr = [];
  translatePosi = [];
  viewport = 0;
  eggStatus = [{
    x: 0, // 蛋蛋圆心的位置
    y: 0, // 蛋蛋圆心的位置
    speedX: 0,
    speedY: 0,
    directionX: 0, // 左 -1 | 右 1
    directionY: 0, // 上 -1 | 下 1
    radius: 0,
  }];
  backupEggOriginPosition = [{
    x: 0,
    y: 0
  }]
  _animationPlayBind = null;
  _animationStopBind = null;
  constructor() {
    let device = deviceType()
    if (device === 'pc') {
      this.viewport = 1920;
      this.translatePosi = translatePosiPC;
    } else {
      this.viewport = 750;
      this.translatePosi = translatePosiMobile;
    }
    this._animationPlayBind = this._animationPlay.bind(this);
    this._animationStopBind = this._animationStop.bind(this);
    for (let i = 0, length = this.eggStatus.length; i < length; i++) {
      this.stopMark.push(0);
    }
    // 获取容器
    this.container = document.querySelector('.j-egg-container');
    // 获取蛋蛋
    for (let i = 0, length = 10; i < length; i++) {
      const ELEMENT = document.querySelector(`.j-egg-${i + 1}`);
      this.eggsArr.push(ELEMENT);
    }
    // 在onload后再计算
    window.addEventListener('load', () => {
      this._initOnload();
    })
  }
  _initOnload() {
    this._initContainer();
    this._initEggs();
    this.isInit = true;
  }
  _initContainer() {
    let device = deviceType();
    if (device == 'pc') {
      this.containerWidth = 412;
      this.containerHeight = 260;
    } else {
      this.containerWidth = 490;
      this.containerHeight = 320;
    }
  }
  _initEggs() {
    this.eggStatus = [];
    this.backupEggOriginPosition = [];
    for (let i = 0, length = this.eggsArr.length; i < length; i++) {
      const EGG = this.eggsArr[i];
      let { width, height } = EGG.getBoundingClientRect();
      let { offsetLeft, offsetTop } = EGG;
      let speedX = Math.ceil(Math.random() * 5) + 5;
      let speedY = Math.ceil(Math.random() * 5) + 5;
      let directionX = Math.random() > 0.5 ? 1 : -1;
      let directionY = Math.random() > 0.5 ? 1 : -1;
      let radius = Math.ceil((width > height ? width : height) / 2);
      let egg = {
        width,
        height,
        directionX,
        directionY,
        speedX,
        speedY,
        radius,
        rotate: 0,
        x: this.translatePosi[i].x,
        y: this.translatePosi[i].y
        // x: (offsetLeft + radius) | 0,
        // y: (offsetTop + radius) | 0,
      }
      // 初始样式
      EGG.style.transitionDuration = 1000 / 60 + 'ms';
      // EGG.style.top = offsetTop + 'px';
      // EGG.style.left = offsetLeft + 'px';
      // EGG.style.transform = `translate3D(${offsetLeft}px, ${offsetTop}px, 0)`;
      this.eggStatus.push(egg);
      this.backupEggOriginPosition.push({
        x: offsetLeft,
        y: offsetTop
      })
    }
  }
  reset() {
    // 数据初始化
    for (let i = 0, length = this.eggStatus.length; i < length; i++) {
      this.stopMark[i] = 0;
    }
    // 让机器的蛋归位
    // for (let i = 0, length = this.backupEggOriginPosition.length; i < length; i++) {
    //   const EGG = this.eggsArr[i];
    //   let { x, y } = this.backupEggOriginPosition[i];
    // EGG.style.top = y + 'px';
    // EGG.style.left = x + 'px';
    // EGG.style.transform = `translate3D(${x}px, ${y}px, 0)`;
    // }
    this._resetEggPosi();

    // 让弹出来的蛋消失
    document
      .querySelector('.j-egg-show')
      .classList
      .remove(`egg-show-${this.randomIndex}`);
  }
  _resetEggPosi() {
    for (let i = 0, length = this.eggsArr.length; i < length; i++) {
      const EGG = this.eggsArr[i];
      const EGG_STATUS = this.eggStatus[i];
      let { x, y } = this.translatePosi[i];
      EGG_STATUS.x = x;
      EGG_STATUS.y = y;
      x = x / this.viewport * 100 + 'vw';
      y = y / this.viewport * 100 + 'vw';
      EGG.style.transform = `translate3D(${x}, ${y}, 0)`;
    }
  }
  async start() {
    if (this.isPlaying) {
      return;
    }
    this.reset();
    this.isPlaying = true;
    // 第一轮动画：扭蛋播放
    this.frame = window.requestAnimationFrame(this._animationPlayBind);
    await new Promise((resolve) => {
      setTimeout(() => {
        // 扭蛋动画结束了
        this.frame = window.cancelAnimationFrame(this.frame);
        resolve();
      }, 2000)
    })
    // 弹出一个蛋
    this._animationResult();
    // 第二轮动画：滚动的蛋要掉回下来
    this.stopFrame = window.requestAnimationFrame(this._animationStopBind);
    // 判断动画全部结束
    await new Promise((resolve) => {
      let timer = null;
      timer = setInterval(() => {
        if (!this.isPlaying) {
          clearInterval(timer);
          resolve();
        }
      }, 1000)
    })

    return Promise.resolve();
  }
  _animationPlay() {
    // console.log('paly');
    for (let i = 0, length = this.eggStatus.length; i < length; i++) {
      const EGG = this.eggStatus[i];
      // 边缘碰撞检测，改变运动方向
      let minX = 0,
        minY = 0,
        maxX = this.containerWidth - EGG.width * 1.8,
        maxY = this.containerHeight - EGG.height;
      // 碰上
      EGG.y <= minY && (EGG.directionY = 1);
      // 碰下
      EGG.y >= maxY && (EGG.directionY = -1);
      // 碰左
      EGG.x <= minX && (EGG.directionX = 1);
      // 碰右
      EGG.x >= maxX && (EGG.directionX = -1);
      // 蛋蛋运动
      // console.log(EGG);
      EGG.rotate += 6;
      EGG.rotate >= 360 && (EGG.rotate = 0);
      EGG.y = (EGG.y + EGG.speedY * EGG.directionY);
      EGG.x = (EGG.x + EGG.speedX * EGG.directionX);
      let x = EGG.x / this.viewport * 100;
      let y = EGG.y / this.viewport * 100;

      // console.log(EGG.y, EGG.speedY, EGG.directionY);

      // this.eggsArr[i].style.top = EGG.y + 'px';
      // this.eggsArr[i].style.left = EGG.x + 'px';
      this.eggsArr[i].style.transform = `translate3D(${x}vw, ${y}vw, 0) rotate(${EGG.rotate}deg)`;
    }

    this.frame = window.requestAnimationFrame(this._animationPlayBind);
  }
  _animationStop() {
    if (!this.stopMark.includes(0)) {
      // console.log('stop');
      this.isPlaying = false;
      window.cancelAnimationFrame(this.stopFrame);
      return;
    }
    for (let i = 0, length = this.eggStatus.length; i < length; i++) {
      const EGG = this.eggStatus[i];
      EGG.y = EGG.y + EGG.speedY;
      if (EGG.y >= this.containerHeight - EGG.height) {
        this.stopMark[i] = 1;
        continue;
      }
      this.eggStatus[i].rotate += 6;
      // this.eggsArr[i].style.top = EGG.y + 'px';
      let x = EGG.x / this.viewport * 100;
      let y = EGG.y / this.viewport * 100;
      this.eggsArr[i].style.transform = `translate3D(${x}vw, ${y}vw, 0) rotate(${this.eggStatus[i].rotate}deg)`;
    }
    this.stopFrame = window.requestAnimationFrame(this._animationStopBind);
  }
  _animationResult() {
    this.randomIndex = Math.ceil(Math.random() * 10);
    document
      .querySelector('.j-egg-show')
      .classList
      .add(`egg-show-${this.randomIndex}`);
  }
  get(key) {
    return this[key];
  }
  set(key, value) {
    this[key] = value;
  }
}


export default Animation;
